// @flow
import React from 'react'
import Button from '../Button'

type Props = {
  login?: string,
  signup?: string
}

const FB_AUTH_URL =
  'https://www.facebook.com/v6.0/dialog/oauth?client_id=1812024199040442&redirect_uri=https://www.kiefrealty.com/auth/facebook/callback&scope=public_profile,email&response_type=token'

const FacebookAuth = ({ login, signup }: Props) => (
  <div style={{ margin: '2rem 0', textAlign: 'center' }}>
    <Button
      style={{ backgroundColor: '#3b5998', color: '#fff', border: 0 }}
      href={FB_AUTH_URL}
    >
      <span className="fa fa-facebook" style={{ marginRight: '6px' }} />
      {login && 'Login'}
      {signup && 'Signup'} with Facebook
    </Button>
  </div>
)

export default FacebookAuth



// WEBPACK FOOTER //
// ./src/components/FacebookAuth/index.js